export default __webpack_public_path__ + "static/media/landscapetable.8128f98f.webp";